import { nanoid } from "nanoid"
import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { api, baseURL, superAdminReqConfig } from "../../include/api"
import Error from "../add-ons/Error"
import Spinner from "../add-ons/Spinner"
import SuperAdminHeader from "./Header"

const SuperAdminBrand = () => {
    const [fetchLoading, setFetchLoading] = useState(true)
    const [brandList, setBrandList] = useState([])
    const [searchQuery, setSearchQuery] = useState("")
    
    useEffect(() => {
        getBrand()
    }, [])

    const getBrand = (afterGet) => {
        setFetchLoading(true)
        api.get("/category/", superAdminReqConfig()).then(response => {
            if (response.status === 200) {
                setBrandList(response.data.data)
                if (afterGet) afterGet(response.data.data)
            }
        }).catch(error => {
            setBrandList([])
            if (afterGet) afterGet([])
        }).finally(() => setFetchLoading(false))
    }

    const handleSearch = (event) => {
        setSearchQuery(event.target.value)
    }

    const filteredBrands = brandList.filter(brand => 
        brand.name.toLowerCase().includes(searchQuery.toLowerCase())
    )

    return <SuperAdminHeader >
        <div style={{ paddingTop: "100px", paddingBottom: "100px" }}>
            <div className="container mt-2 mb-5">
                <div className="py-3 d-flex justify-content-between align-items-center">
                    <h5 className="m-0">Brand</h5>
                    <Link to="/super/add-brand" className="btn btn-success">Add new Brand</Link>
                </div>
                <div className="py-3">
                    <input 
                        type="text" 
                        className="form-control" 
                        placeholder="Search Brands..." 
                        value={searchQuery} 
                        onChange={handleSearch} 
                    />
                </div>
                            <div className="py-1 small">
                Total Brands: {filteredBrands.filter(f => String(f.parentId) === '-1').length}
            </div>
                    {fetchLoading ?
                    <Spinner color="danger" spinnerSize="lg" /> :
                    filteredBrands.length > 0 ? 
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Image</th>
                                    <th>Name</th>
                                    {/* <th>Category</th> */}
                                    <th>Description</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredBrands.filter(f => String(f.parentId) === '-1').map((brand, index) => {
                                    return <BrandRow brand={brand} index={index + 1} key={nanoid()} />
                                })}
                            </tbody>
                        </table> : <Error mainText="No brand found!" secondaryText={<Link to="/super/add-brand">Add New brand</Link>} />}
            </div>
        </div>
    </SuperAdminHeader>
}

const BrandRow = ({ brand, index }) => {
    return <tr>
        <td>{index}</td>
        <td>
            <img src={baseURL + "/" + brand.imageUrl} alt="" className="fit-contain w-100 h-100" style={{ maxWidth: "100px" }} />
        </td>
        <td>{brand.name}</td>
        {/* <td>{brand.categoryName}</td> */}
        <td>{brand.description}</td>
        <td className="zn-1">
            <Link to={`/super/edit-brand/${brand.id}`} className="btn btn-sm btn-primary">Edit</Link>
            {/* <button className="btn btn-link text-danger">Delete</button> */}
        </td>
    </tr>
}

export default SuperAdminBrand